import { createPinia } from 'pinia'

// A single Pinia instance alongside the existing Vuex store; no Vuex replacement.
export const memcorePinia = createPinia()